export const SEARCH_RESULT_CAP = 16

export const normalizeSearchText = (value?: string | null): string =>
  (value || '').trim().toLowerCase()

export const matchesQuery = (
  haystacks: Array<string | undefined | null>,
  query: string,
): boolean => {
  const term = normalizeSearchText(query)
  if (!term) return false
  return haystacks.some((entry) => normalizeSearchText(entry).includes(term))
}

export const capResults = <T>(items: T[], limit = SEARCH_RESULT_CAP): T[] => items.slice(0, limit)

export const highlightPrefix = (
  text: string,
  query: string,
): { before: string; match: string; after: string } | null => {
  const term = query.trim()
  if (!term) return null
  const index = text.toLowerCase().indexOf(term.toLowerCase())
  if (index < 0) return null
  return {
    before: text.slice(0, index),
    match: text.slice(index, index + term.length),
    after: text.slice(index + term.length),
  }
}
